import type { AulaState } from '@core/types/state';
import type { GuidedToursState } from '@app/reducers/guidedTours';
import { isGuidedTourCompleted } from '@app/utils/guidedTourStorage';

type StateWithGuidedTours = AulaState & {
  guidedTours: GuidedToursState;
};

export const getGuidedToursState = (
  state: StateWithGuidedTours
): GuidedToursState => state.guidedTours;

export const getGuidedTours = (state: StateWithGuidedTours) =>
  getGuidedToursState(state).tours;

export const getGuidedToursStatus = (state: StateWithGuidedTours) =>
  getGuidedToursState(state).status;

export const isTourCompletedSelector = (
  state: StateWithGuidedTours,
  tourId: string,
  variant: string
): boolean => isGuidedTourCompleted(getGuidedTours(state), tourId, variant);

export const areGuidedTourPreferencesResolved = (
  state: StateWithGuidedTours,
  tourId: string,
  variant: string
): boolean => {
  const status = getGuidedToursStatus(state);
  if (isTourCompletedSelector(state, tourId, variant)) {
    return true;
  }
  return status === 'ready' || status === 'error';
};
